export let mockGetSignupListInfo = {
  success: true,
  signupList: {
    ID: 11,
    title: "Mocked Test Event",
    description: "",
    media: {
      type: "none",
    },
    backgroundColor: "#016099",
    backgroundColorScheme: ["#016099", "#13426B"],
    createdBy: { userID: 2, name: "Super Admin", date: 1688999862 },
    options: {
      allowMultipleItemSignups: 1,
      shared: 1,
      public: 1,
      expireDate: 0,
      sendReminderAt: 0,
      showConfetti: 1,
    },
    signupListVerbs: {
      ID: 1,
      title: "an Event",
      entity: "spot",
      entityPlural: "spots",
      actionName: "Sign Up",
      actionAsATitle: "Sign up for",
      actionNamePresentTense: "signing up",
      cancelName: "Cancel",
      howManyQuestion: "How many people are coming?",
      confirmOne: "you're in!",
      confirmMultiple: "you're in for # people!",
      cancelOne: "We've cancelled your spot for this event.",
      cancelMultiple: "We've cancelled your spots for this event.",
      status: 1,
    },
    signupListStatusID: 1,
    scheduledReminderSent: [],
    manualRemindersSent: [],
    signupListTypeID: 1,
    // fund: {
    //   ID: 10,
    //   name: "Signup - All New Test Event",
    //   confirmationMessage: null,
    //   signupPaymentsCollected: false,
    // },
    isSuggestedDonation: false,
    fundIt: {
      blockAutomaticRefunds: true,
      isSuggestedDonation: false,
      hasSignupCost: true,
      fund: {
        ID: 3,
        name: "Galaxy Fund",
        confirmationMessage: null,
        signupPaymentsCollected: false,
      },
      // This is only here if costType = PerSignup
      cost: {
        costType: "PerSignup",
        amounts: [
          {
            numberOfSlots: null,
            amount: 10000,
          },
        ],
      },
    },
    blockAutomaticRefunds: true,
    signupItems: [
      {
        ID: 28,
        hasFundIt: true,
        numberOfRespondents: 2,
        name: "Nose Bleeds",
      },
      {
        ID: 29,
        name: "Club Level",
        numberOfRespondents: 3,
        hasFundIt: true,
      },
      {
        ID: 30,
        name: "50 Yard Line",
        numberOfRespondents: 1,
        hasFundIt: true,
      },
    ],
  },
  notes: [],
  network: {
    ID: 2,
    name: "Test Net",
    hasSignupPayments: true,
  },
  user: {
    ID: 2,
    firstName: "Super",
    lastName: "Admin",
    email: {
      ID: 2,
      type: "email",
      status: "active",
      verified: true,
      address: "superadmin@testnet.com",
    },
    isAdminOfAnyGroup: true,
    canSignupHouseholdMembers: false,
    household: [],
    householdID: 1,
  },
  userSignupItems: {
    30: {
      count: 2,
      respondents: [
        {
          name: "Tink Wing",
          isAdditionalName: true,
          userID: null,
          additionalNameID: 74,
          paymentStatus: null,
        },
        {
          name: "Super Admin",
          isAdditionalName: false,
          userID: 2,
          additionalNameID: 75,
          paymentStatus: null,
        },
      ],
    },
  },
  allSignupListTypes: [
    {
      ID: 1,
      title: "an Event",
    },
    {
      ID: 2,
      title: "Seats",
    },
    {
      ID: 4,
      title: "a Poll",
    },
    {
      ID: 5,
      title: "Items",
    },
    {
      ID: 7,
      title: "Volunteers",
    },
  ],
  isApp: false,
  userID: 2,
};
